import NewsOverview from"./src/NewsOverview";if(!window.customElements.get("news-overview")){window.customElements.define("news-overview",NewsOverview)}